{
  "admission": "入院",
  "transfer": "轉科",
  "visit": "求診",
  "type": "求診類型",
  "status": "狀態",
  "location": "科室位置",
  "attendingPhysician": "主診醫生",
  "admitDate": "入院日期",
  "dischargeDate": "出院日期",
  "chiefComplaint": "主訴",
  "diagnosis": "診斷",
  "class": {
    "label": "類別",
    "values": {
      "emergency": "急症",
      "inpatient": "住院",
      "outpatient": "門診",
      "observation": "留院觀察",
      "ambulatory": "日間診療",
      "homeHealth": "家居醫療",
      "virtual": "視像診症"
    }
  },
  "statusValues": {
    "label": "狀態",
    "values": {
      "pending": "待處理",
      "arrived": "已到達",
      "active": "進行中",
      "completed": "已完成",
      "cancelled": "已取消"
    }
  },
  "admissionSource": {
    "label": "入院來源",
    "none": "—",
    "values": {
      "emergency": "急症室",
      "clinicReferral": "門診轉介",
      "physicianReferral": "醫生轉介",
      "transfer": "由其他醫院轉入",
      "self": "自行求診 / 步入",
      "courtLaw": "司法 / 執法機關"
    }
  },
  "admissionType": {
    "label": "入院類型",
    "none": "—",
    "values": {
      "elective": "預約",
      "emergency": "急症",
      "urgent": "緊急",
      "newborn": "初生嬰兒",
      "trauma": "創傷"
    }
  },
  "acuity": {
    "label": "病情等級",
    "none": "—",
    "values": {
      "1": "1 — 搶救",
      "2": "2 — 危殆",
      "3": "3 — 緊急",
      "4": "4 — 次緊急",
      "5": "5 — 非緊急"
    },
    "shortValues": {
      "1": "搶救",
      "2": "危殆",
      "3": "緊急",
      "4": "次緊急",
      "5": "非緊急"
    },
    "esiBadge": "ESI {{level}} - {{label}}"
  },
  "form": {
    "title": "新增求診",
    "subtitle": "為此病人開始新的求診 / 入院。",
    "sections": {
      "visit": "求診資料",
      "reasonForVisit": "求診原因",
      "admission": "入院資料"
    },
    "fields": {
      "facility": "院舍",
      "encounterClass": "求診類別",
      "encounterType": "求診類型",
      "department": "部門",
      "attendingProvider": "主診醫生",
      "acuity": "病情等級",
      "visitReason": "求診原因",
      "chiefComplaint": "主訴",
      "admissionSource": "入院來源",
      "admissionType": "入院類型"
    },
    "placeholders": {
      "selectFacility": "選擇院舍",
      "none": "—",
      "encounterType": "例如:周年體檢、急症求診",
      "visitReason": "簡短標籤,例如:覆診、周年體檢",
      "chiefComplaint": "病人以自己用語說明的求診原因"
    },
    "providerFallback": "醫生 #{{id}}",
    "submit": "建立求診",
    "validation": {
      "facilityRequired": "請選擇院舍",
      "encounterClassRequired": "請選擇求診類別"
    },
    "createdSuccess": "求診已建立",
    "createError": "建立求診失敗"
  },
  "detail": {
    "loading": "正在載入求診資料...",
    "notFound": "找不到此求診",
    "loadError": "載入就診失敗",
    "retry": "重試",
    "returnToDashboard": "返回主控台",
    "header": {
      "title": "求診 {{number}}",
      "facilityLabel": "院舍 #{{id}}",
      "departmentLabel": "部門 #{{id}}",
      "locationLabel": "位置 #{{id}}",
      "admittedLabel": "入院時間:{{datetime}}"
    },
    "actions": {
      "transfer": "轉科",
      "discharge": "出院"
    },
    "tabs": {
      "overview": "概覽",
      "orders": "醫囑",
      "results": "化驗結果",
      "medications": "藥物",
      "notes": "病歷",
      "billing": "收費"
    },
    "overview": {
      "chiefComplaint": "主訴",
      "visitReason": "求診原因",
      "attendingProvider": "主診醫生",
      "acuityLevel": "病情等級",
      "providerFallback": "醫生 #{{id}}",
      "empty": "--"
    },
    "timeline": {
      "title": "事件時間軸",
      "empty": "未有事件紀錄",
      "admittedTitle": "入院",
      "admittedDescription": "{{class}} - {{chiefComplaint}}",
      "noChiefComplaint": "未有主訴",
      "orderTitle": "醫囑:{{name}}",
      "orderDescription": "{{type}} - {{priority}} - {{status}}",
      "resultTitle": "結果:{{type}}"
    },
    "orders": {
      "title": "醫囑",
      "newOrder": "+ 新增醫囑",
      "empty": "此求診暫無醫囑",
      "metaLine": "{{number}} | {{type}} | 優先次序:{{priority}}"
    },
    "results": {
      "title": "化驗結果",
      "empty": "此求診暫無化驗結果",
      "criticalBadge": "危急",
      "viewLink": "查看",
      "metaLine": "{{number}} | {{status}}"
    },
    "medications": {
      "title": "藥物",
      "newMedication": "+ 新增藥物",
      "empty": "此求診暫無藥物紀錄",
      "prnBadge": "PRN",
      "prnWithIndication": "PRN:{{indication}}"
    },
    "notes": {
      "comingSoon": "臨床病歷模組即將推出",
      "goToClinicalNotes": "前往臨床病歷"
    },
    "billing": {
      "comingSoon": "收費模組即將推出"
    }
  },
  "census": {
    "title": "床位概況 / 在院名冊",
    "subtitle": "實時床位佔用及病人在院情況",
    "refresh": "重新整理",
    "facilityName": "新加坡中央醫院",
    "capacitySummary": "已用 {{occupied}} / 共 {{total}} 張床位",
    "occupancyLabel": "佔用率 {{percent}}%",
    "stats": {
      "totalCapacity": "床位總數",
      "occupied": "已佔用",
      "available": "可用",
      "pendingDischarge": "待出院"
    },
    "unitFilter": {
      "all": "全部病房",
      "er": "ER",
      "icu": "ICU",
      "medsurg": "內外科",
      "obs": "觀察室",
      "peds": "兒科",
      "maternity": "產科"
    },
    "roleView": {
      "nurse": "護士檢視",
      "physician": "醫生檢視",
      "bedManager": "床位管理檢視"
    },
    "viewMode": {
      "grid": "格狀檢視",
      "table": "表格檢視"
    },
    "loading": "正在載入在院資料...",
    "columns": {
      "patient": "病人",
      "mrn": "MRN",
      "admitDate": "入院日期",
      "status": "狀態",
      "acuity": "病情等級",
      "isolation": "隔離",
      "fallRisk": "跌倒風險",
      "codeStatus": "搶救等級",
      "chiefComplaint": "主訴",
      "attending": "主診",
      "los": "LOS",
      "locationBed": "位置 / 床位",
      "transferStatus": "轉科狀態",
      "expectedDischarge": "預計出院",
      "actions": "操作"
    },
    "values": {
      "unknownPatient": "未知",
      "none": "無",
      "notAvailable": "N/A",
      "pending": "待處理",
      "empty": "--",
      "providerFallback": "醫生 #{{id}}",
      "locationLabel": "位置 #{{id}}",
      "losDays": "{{days}}日"
    },
    "codeStatusTooltip": "搶救等級可於病人病歷查閱",
    "actionsMenu": {
      "label": "操作",
      "viewChart": "查看病歷",
      "transfer": "轉科",
      "assignAttending": "分配主診醫生",
      "discharge": "出院"
    },
    "empty": "暫無在院求診",
    "department": {
      "filteredTo": "僅顯示 {{name}}",
      "idLabel": "科室 {{id}}",
      "showAll": "顯示所有科室"
    },
    "facility": {
      "label": "機構",
      "allFacilities": "所有機構",
      "idLabel": "機構 {{id}}"
    }
  },
  "discharge": {
    "label": "出院",
    "title": "出院流程",
    "encounterLabel": "求診 {{number}}",
    "printButton": "列印出院記錄",
    "loading": "正在載入求診資料...",
    "notFound": "找不到該求診",
    "returnToDashboard": "返回主控台",
    "notActive": "該求診並非進行中(目前狀態:{{status}})",
    "backToEncounter": "返回求診頁",
    "progress": {
      "requiredMissingTooltip": "必填欄位未填",
      "tasksRemainingTooltip": "尚有未完成項目"
    },
    "steps": {
      "summary": "出院摘要",
      "medications": "用藥",
      "followup": "覆診",
      "instructions": "出院指引",
      "nursing": "護理任務",
      "signoff": "主診醫生簽核",
      "review": "覆核及確認"
    },
    "summary": {
      "title": "出院摘要",
      "diagnosisLabel": "出院診斷 *",
      "diagnosisPlaceholder": "請輸入出院診斷...",
      "diagnosisCodeLabel": "出院診斷編碼(ICD-10)",
      "diagnosisCodePlaceholder": "搜尋 ICD-10 編碼...",
      "proceduresLabel": "已執行的處置",
      "proceduresPlaceholder": "列出本次求診期間執行的處置...",
      "conditionLabel": "出院時情況 *"
    },
    "condition": {
      "values": {
        "stable": "穩定",
        "improved": "好轉",
        "unchanged": "無變化",
        "worsened": "惡化",
        "critical": "危殆"
      }
    },
    "medications": {
      "title": "出院帶藥",
      "instructions": "請逐項覆核每種藥物,並決定繼續、停用或調整。",
      "actions": {
        "continue": "繼續",
        "stop": "停用",
        "modify": "調整"
      },
      "modifiedPlaceholder": "請輸入調整後的用藥指引...",
      "empty": "本次求診暫無在用藥物"
    },
    "medAction": {
      "values": {
        "continue": "繼續",
        "stop": "停用",
        "modify": "調整"
      }
    },
    "followup": {
      "title": "覆診安排",
      "providerLabel": "覆診醫生",
      "providerPlaceholder": "醫生姓名或專科...",
      "dateLabel": "覆診日期",
      "notesLabel": "其他備註",
      "notesPlaceholder": "其他覆診備註..."
    },
    "instructions": {
      "title": "病人出院指引",
      "generalLabel": "一般指引",
      "generalPlaceholder": "提供給病人的一般出院指引...",
      "dietaryLabel": "飲食指引",
      "dietaryPlaceholder": "飲食限制或建議...",
      "activityLabel": "活動限制",
      "activityPlaceholder": "身體活動限制...",
      "warningSignsLabel": "需留意的症狀",
      "warningSignsPlaceholder": "出現這些症狀時病人應及時覆診或求醫..."
    },
    "nursing": {
      "title": "護理任務",
      "instructions": "出院前請完成以下清單。此處項目僅作紀錄,不會調用 API。",
      "tasks": {
        "removeIv": "拔除 IV 通路",
        "discontinueMonitoring": "停用監察儀器",
        "patientEducation": "完成病人健康教育",
        "medsReviewed": "已與病人核對出院帶藥",
        "belongingsReturned": "歸還個人物品",
        "transportArranged": "已安排離院交通"
      }
    },
    "signoff": {
      "title": "主診醫生簽核",
      "instructions": "請覆核下列出院摘要後,完成主診醫生簽核。",
      "diagnosisHeading": "出院診斷",
      "notProvided": "未填寫",
      "medicationsHeading": "出院帶藥",
      "noMedications": "無須核對藥物",
      "signedCompleted": "主診醫生簽核已完成。",
      "signAsAttending": "以主診醫生身份簽核",
      "requiresAttendingSignoff": "需主診醫生簽核"
    },
    "review": {
      "title": "覆核及確認出院",
      "summaryHeading": "出院摘要",
      "fields": {
        "diagnosis": "診斷:",
        "procedures": "處置:",
        "condition": "情況:",
        "provider": "醫生:",
        "date": "日期:",
        "notes": "備註:",
        "general": "一般:",
        "diet": "飲食:",
        "activity": "活動:",
        "warningSigns": "警覺症狀:"
      },
      "medicationsHeading": "藥物核對",
      "noMedications": "無須核對藥物",
      "followupHeading": "覆診",
      "instructionsHeading": "出院指引",
      "noInstructions": "未提供出院指引",
      "pendingOrdersWarning": "可能仍有未完成醫囑或未簽核病歷,完成出院前請確認。",
      "diagnosisRequired": "完成出院前必須填寫出院診斷。",
      "empty": "--"
    },
    "nav": {
      "previous": "上一步",
      "next": "下一步",
      "complete": "完成出院"
    },
    "toast": {
      "success": "病人已成功出院",
      "error": "完成出院失敗"
    }
  },
  "components": {
    "transferDialog": {
      "title": "轉移就診",
      "description": "將病人轉至本機構內的其他位置。",
      "targetLocationLabel": "目標位置",
      "loadingLocations": "正在載入位置…",
      "selectLocation": "請選擇位置",
      "emptyState": "本機構內沒有其他啟用中嘅位置。",
      "reasonLabel": "原因",
      "reasonPlaceholder": "例如：需要隔離、深切治療部降階、需要更高護理級別床位",
      "actions": {
        "transfer": "轉移"
      },
      "toasts": {
        "success": "就診已轉移",
        "error": "轉移就診失敗"
      }
    },
    "assignAttendingDialog": {
      "title": "分配主診醫生",
      "description": "設定負責此次就診的主診醫生。",
      "providerLabel": "主診醫生",
      "loadingProviders": "正在載入醫生…",
      "selectProvider": "選擇醫生",
      "emptyState": "此機構目前沒有在職醫生。",
      "actions": {
        "assign": "分配"
      },
      "toasts": {
        "success": "主診醫生已分配",
        "error": "無法分配主診醫生"
      }
    },
    "bedBoard": {
      "bedStatus": {
        "available": "可用",
        "occupied": "佔用",
        "reserved": "預留",
        "cleaning": "清潔中",
        "closed": "關閉",
        "isolated": "隔離",
        "contaminated": "已污染"
      },
      "acuityLegendLabel": "ESI 急症分級：",
      "empty": "未設定病房",
      "summary": {
        "available_one": "{{count}} 可用",
        "available_other": "{{count}} 可用",
        "occupied_one": "{{count}} 佔用",
        "occupied_other": "{{count}} 佔用",
        "reserved_one": "{{count}} 預留",
        "reserved_other": "{{count}} 預留",
        "cleaning_one": "{{count}} 清潔中",
        "cleaning_other": "{{count}} 清潔中",
        "closed_one": "{{count}} 關閉",
        "closed_other": "{{count}} 關閉",
        "isolated_one": "{{count}} 隔離",
        "isolated_other": "{{count}} 隔離",
        "contaminated_one": "{{count}} 已污染",
        "contaminated_other": "{{count}} 已污染"
      }
    },
    "protocolPanel": {
      "title": "方案登記",
      "enroll": "登記",
      "availableProtocols": "可用方案",
      "loadingProtocols": "正在載入方案...",
      "noProtocols": "暫無可用方案",
      "stepBadge": "步驟 {{current}}/{{total}}",
      "loadingEnrollments": "正在載入登記...",
      "noEnrollments": "暫無有效的方案登記",
      "completeStep": "完成步驟",
      "toasts": {
        "enrollSuccess": "已登記方案",
        "enrollError": "方案登記失敗",
        "advanceSuccess": "步驟已完成",
        "advanceError": "步驟推進失敗"
      }
    }
  }
}
